<script lang="ts">
import { useResetPassword, useSignInEmailPassword } from '@nhost/vue';
import { useLocale } from 'vuetify';
export default {
  setup() {
    const { t } = useLocale();
    const getTranslation = (path: string) => t(path);
    return {
      getTranslation,
    };
  },
  data() {
    return {
      email: '',
      resetPassword: (email: string) => console.log(email),
      sentEmailAlert: false,
    };
  },
  created() {
    const { resetPassword } = useResetPassword({
      redirectTo: import.meta.env.VITE_APP_CHANGE_PASSWORD_URL,
    });
    const { user } = useSignInEmailPassword();
    if (user.value?.id) this.$router.push('/app');
    this.resetPassword = resetPassword as any;
  },
  methods: {
    async handleSubmit(event: Event) {
      event.preventDefault();
      await this.resetPassword(this.email);
      this.sentEmailAlert = true;
    },
    async handleRedirectTo(route: string) {
      this.$router.push(route);
    },
  },
};
</script>

<template>
  <div class="forgot-password pa-10 d-flex">
    <div class="w-75">
      <v-img eager height="75" class="mb-5" src="@/assets/logo_cockpit_full_svg.svg" />
      <div class="justify-start">
        <h3>{{ getTranslation('$vuetify.auth.forgot-password.message.title') }}</h3>
        <p class="forgot-password-text-body">
          {{ getTranslation('$vuetify.auth.forgot-password.message.text') }}
        </p>
      </div>
      <v-form @submit="handleSubmit">
        <v-text-field
          class="mt-3"
          variant="outlined"
          v-model="email"
          type="email"
          :label="getTranslation('$vuetify.auth.forgot-password.email.label')"
        />
        <br />
        <v-alert
          v-model="sentEmailAlert"
          type="success"
          variant="tonal"
          color="white"
          border="start"
          closable
          :text="getTranslation('$vuetify.auth.forgot-password.email-sent-alert.text')"
        />
        <br />
        <v-btn class="btn-submit text-none" color="primary" min-width="100%" type="submit">
          <span class="text-white">
            {{ getTranslation('$vuetify.auth.forgot-password.send-link-btn.text') }}
          </span>
        </v-btn>
        <div class="d-flex flex-row-reverse">
          <p class="mt-5 sign-in-text" @click="handleRedirectTo('sign-in')">
            {{ getTranslation('$vuetify.auth.forgot-password.sign-in-btn.text') }}
          </p>
        </div>
      </v-form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.forgot-password {
  justify-content: center;
  align-items: center;
}

.sign-in-text {
  color: rgb(var(--v-theme-primary));
  cursor: pointer;
}

.forgot-password-text-body {
  color: rgb(var(--v-theme-text-body-secondary));
}
</style>
